import React from 'react';
import { useLocation } from 'react-router-dom';
import { useBoundaries } from '../hooks/useBoundaries';
import { isBeforeBoundary, periodShown } from '../utils/boundary';
import * as fmt from '../lib/format';
import InfoTip from './InfoTip';

// Shown under the page header when the period in the address is before the Jira conventions started: those
// months are still readable, but they are not compared with later ones. Reads the address, so every page
// that keeps its period there gets it without asking.
export default function BeforeBoundaryNotice() {
  const { pathname, search } = useLocation();
  const boundaries = useBoundaries();
  const period = periodShown(pathname, new URLSearchParams(search));
  if (!boundaries || !isBeforeBoundary(period, boundaries)) return null;
  return (
    <div role="note" className="flex flex-wrap items-center gap-x-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 sm:px-6">
      <span className="font-semibold">{boundaries.label}.</span>
      <span>This period is from before the Jira conventions started, so its numbers are not compared with later months.</span>
      <InfoTip id="planning.tech_from" vars={{ from: fmt.month(boundaries.month) }} className="" />
    </div>
  );
}
